const AppSpinner = () => (
	<div className="flex justify-center items-center">
		<div className="w-6 h-6 border-4 border-blue-800 border-t-transparent rounded-full animate-spin"></div>
	</div>
);

export default AppSpinner;
